import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowDownCircle, ArrowUpCircle, CalendarDays, Handshake, Users, StickyNote } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import TransactionDialog from "@/components/TransactionDialog";
import DailyRevenueDialog from "@/components/DailyRevenueDialog";

export default function AddDialog({ open, onOpenChange }) {
  const navigate = useNavigate();
  const [txType, setTxType] = useState(null);
  const [daily, setDaily] = useState(false);

  const actions = [
    { icon: ArrowDownCircle, label: "Recette", color: "text-emerald-600 bg-emerald-50", onClick: () => { onOpenChange(false); setTxType("income"); } },
    { icon: ArrowUpCircle, label: "Dépense", color: "text-rose-600 bg-rose-50", onClick: () => { onOpenChange(false); setTxType("expense"); } },
    { icon: CalendarDays, label: "Encaissement journalier", color: "text-blue-600 bg-blue-50", onClick: () => { onOpenChange(false); setDaily(true); } },
    { icon: Handshake, label: "Rétrocession", color: "text-violet-600 bg-violet-50", onClick: () => { onOpenChange(false); navigate("/retrocessions"); } },
    { icon: Users, label: "Salaire", color: "text-amber-600 bg-amber-50", onClick: () => { onOpenChange(false); navigate("/equipe"); } },
    { icon: StickyNote, label: "Note (dépense)", color: "text-gray-600 bg-gray-100", onClick: () => { onOpenChange(false); setTxType("expense"); } },
  ];

  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="rounded-3xl sm:max-w-md" data-testid="quickadd-dialog">
          <DialogHeader>
            <DialogTitle className="font-display text-xl">Ajouter</DialogTitle>
          </DialogHeader>
          <div className="grid grid-cols-2 gap-3 pt-2">
            {actions.map((a) => {
              const Icon = a.icon;
              return (
                <button
                  key={a.label}
                  data-testid={`quickadd-${a.label.split(" ")[0].toLowerCase()}`}
                  onClick={a.onClick}
                  className="flex flex-col items-center gap-2 rounded-2xl border border-gray-100 p-5 text-center text-sm font-semibold text-gray-700 transition-transform hover:-translate-y-0.5 active:scale-95"
                >
                  <span className={`flex h-12 w-12 items-center justify-center rounded-2xl ${a.color}`}>
                    <Icon className="h-6 w-6" />
                  </span>
                  {a.label}
                </button>
              );
            })}
          </div>
        </DialogContent>
      </Dialog>

      <TransactionDialog open={!!txType} onOpenChange={(v) => !v && setTxType(null)} type={txType || "expense"} onSaved={() => window.location.reload()} />
      <DailyRevenueDialog open={daily} onOpenChange={setDaily} onSaved={() => {}} />
    </>
  );
}
